import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase";
import Login from "@/views/Login";
import Index from "@/views/Index";
import EditEvent from "@/views/EditEvent";
import Admin from "@/views/Admin";
import EditCompany from "@/views/EditCompany";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/kirjautuminen",
      name: "Login",
      component: Login,
    },
    {
      path: "/",
      name: "Index",
      component: Index,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/yritys/:companyId",
      name: "IndexCompany",
      component: Index,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/muokkaa/:companyId/:event_slug",
      name: "EditEvent",
      component: EditEvent,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/hallinta",
      name: "Admin",
      component: Admin,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/asiakas/:companyId",
      name: "EditCompany",
      component: EditCompany,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    let user = firebase.auth().currentUser;
    if (user) {
      next();
    } else {
      next({ name: "Login" });
    }
  } else {
    next();
  }
});

export default router;
